// @ts-nocheck
"use client";
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from "boneyard-js";
import { configureBoneyard } from "boneyard-js/react";

import _workflows_card_grid from "./workflows-card-grid.bones.json";
import _run_history_list from "./run-history-list.bones.json";
import _webhooks_inbound_table from "./webhooks-inbound-table.bones.json";

configureBoneyard({
  color: "#D9D9D9",
  darkColor: "#27272a",
  animate: "pulse",
  stagger: 40,
  transition: 200,
  boneClass: "rounded-md",
});

registerBones({
  "workflows-card-grid": _workflows_card_grid,
  "run-history-list": _run_history_list,
  "webhooks-inbound-table": _webhooks_inbound_table,
});
